import React from "react";
import SearchBox from "./Products/SearchBox";
import Products from "./Products/Products";

const Home = () => {
  return (
    <>
      <div className="sticky top-0 z-10">
        <SearchBox />
      </div>

      <div>
        <Products />
      </div>
    </>
  );
};

export default Home;
